    import { useContext } from 'react';
    import { ProductsContext } from '../context/ProductsContext';

    export const useProducts = () => {
    const context = useContext(ProductsContext);
    if (!context) throw new Error('useProducts deve essere usato dentro ProductsProvider');
    return context;
    };